/**
 * @desc Yung-根据包裹单号获取售后单信息
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  params: API.fulfilment.inPlanFacadeImpl.getSaleInBySourceNo.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/inPlan/getSaleInBySourceNo`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
